"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileRepository = exports.InterstitialsRepository = void 0;
class InterstitialsRepository {
    constructor(API) {
        this.API = API;
        this.getInterstitial = () => {
            const url = `${window.MIDDLEWARE_BASE_HOST}/mb-api-interstitials/v1/interstitials?globalPosition=true`;
            return this.API.GET(url);
        };
        this.beginESignProcess = (body) => {
            const url = `${window.MIDDLEWARE_BASE_HOST}/mb-api-terms-n-conds/v1/precontractual-process`;
            return this.API.POST(url, body);
        };
        this.finishESignProcess = (operationProcessId, body) => {
            const url = `${window.MIDDLEWARE_BASE_HOST}/mb-api-terms-n-conds/v1/precontractual-process/${operationProcessId}/documents/submit`;
            return this.API.POST(url, body);
        };
        this.dismissInterstitial = (interstitialType, body) => {
            const url = `${window.MIDDLEWARE_BASE_HOST}/mb-api-customers/v1/customers/me/interstitials/${interstitialType}/dismiss`;
            return this.API.PUT(url, body);
        };
    }
}
exports.InterstitialsRepository = InterstitialsRepository;
class ProfileRepository {
    constructor(API) {
        this.API = API;
        this.getProfile = () => {
            const url = `${window.MIDDLEWARE_BASE_HOST}/mb-api-customers/v2/customers/me`;
            return this.API.GET(url);
        };
    }
}
exports.ProfileRepository = ProfileRepository;
//# sourceMappingURL=repository.js.map